<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!esign">
      <span class="loader"></span>
    </span>
    <esign-form
      v-if="esign"
      :loading="loading"
      :esignData="esign"
      :formErrors="formErrors"
      @esignSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import EsignForm from "../partials/EsignForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";

export default {
  layout: "DashboardLayout",

  components: { EsignForm },

  mixins: [alertLeave],

  props: {
    esignId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      esign: null,
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        await this.$store.dispatch("esigns/get", this.esignId);
        this.esign = this.$store.getters["esigns/esign"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.loading = false;
      }
    },

    async handleSubmit(esign) {
      this.loading = true;
      const esignData = cloneDeep(esign);

      try {
        await this.$store.dispatch("esigns/update", esignData);
        this.$notify({
          type: "success",
          message: this.$t("ESIGNS.ESIGN_UPDATED"),
        });
        const esign = await this.$store.getters["esigns/esign"];
        this.$emit("onViewEsign", esign, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
